<template>
    <Modal
        title="巡检结果"
        v-model="dialogShow"
        :mask-closable="false"
        @on-visible-change="changeHandle"
    >
        <div class="dialog-con">
            <Form ref="formValidate" :model="formValidate" :rules="ruleValidate" :label-width="90">
                <FormItem label="紧急程度:" prop="urgencyLevel" style="margin-bottom: 0;">
                    <RadioGroup v-model="formValidate.urgencyLevel">
                        <Radio :label="0">正常</Radio>
                        <Radio :label="1">一般异常</Radio>
                        <Radio :label="2">紧急异常</Radio>
                    </RadioGroup>
                </FormItem>
                <FormItem prop="imgurl" required>
                    <Upload
                        multiple
                        type="drag"
                        action="/api/upload?dir=inspection"
                        :on-success="upImgSuccess"
                        :on-remove="handleRemove"
                        :with-credentials="true"
                    >
                        <div style="padding: 20px 0;background: #E6EFFF;">
                            <img src="@/assets/photo.png" alt="">
                            <p style="color: #165DFF;font-size: 14px;">上传照片</p>
                        </div>
                    </Upload>
                </FormItem>
                <FormItem prop="remark" required>
                    <i-input v-model="formValidate.remark" type="textarea" :rows="4" placeholder="输入备注"></i-input>
                </FormItem>
            </Form>
            
        </div>
        <div slot="footer">
            <i-button type="default" size="default" @click="cancelHandle">取消</i-button>
            <i-button type="primary" size="default" :loading="modal_loading" @click="okHandle">确认提交</i-button>
        </div>
    </Modal>
</template>
<script>
export default {
    data() {
        const validateImg = (rule, value, callback) => {
            if (!value || value.length === 0) {
                callback(new Error('请上传照片'));
            } else {
                callback();
            }
        };
        
        const validateRemark = (rule, value, callback) => {
            if (!value) {
                callback(new Error('请填写备注'));
            } else {
                callback();
            }
        };
        
        return {
            dialogShow: false,
            remark: null,
            formValidate: {
                remark: null,
                urgencyLevel: 0,  // 默认选择"正常"
                imgurl: []
            },
            ruleValidate: {
                urgencyLevel: [{ required: true, message: "不能为空", trigger: "change", type: "number" }],
                imgurl: [{ validator: validateImg, trigger: 'change' }],
                remark: [{ validator: validateRemark, trigger: 'blur' }]
            },
            modal_loading: false,
            basicData: {
                siteMn: null
            }
        }
    },
    methods: {
        changeHandle(flag) {
            if (!flag) {
                this.formValidate.imgurl = [];
                this.formValidate.remark = "";
                this.formValidate.urgencyLevel = 0;  // 重置为"正常"
                this.$refs.formValidate.resetFields();
            }
        },
        open(data) {
            this.basicData.siteMn = data.siteMn;
            this.dialogShow = true;
        },
        okHandle() {
            this.$refs['formValidate'].validate((valid) => {
                if (valid) {
                    this.modal_loading = true;
                    this.$api.Event.submitIspect(
                        {
                            content: {
                                siteMn: this.basicData.siteMn,
                                urgencyLevel: this.formValidate.urgencyLevel,
                                imgurl: this.formValidate.imgurl.map(item => item.response).join(","),
                                remark: this.formValidate.remark
                            }
                        },
                        ["uuid", "company"]
                    ).then(res => {
                        if (res.code == 0) {
                            this.$Message.success("已提交");
                            this.dialogShow = false;
                            this.$emit("success")
                        } else {
                            this.$Message.warning(res.message);
                        }
                    }).finally(() => {
                        this.modal_loading = false;
                    })
                }
            })
        },
        cancelHandle() {
            this.dialogShow = false
        },
        upImgSuccess(res, file) {
            if (!res.code) {
                this.formValidate.imgurl.push(file);
                this.$refs.formValidate.validateField('imgurl');
            } else {
                this.$Notice.warning({
                    title: "上传失败",
                    desc: res.message
                });
            }
        },
        handleRemove(res) {
            this.formValidate.imgurl.splice(
                this.formValidate.imgurl.findIndex(item => item.response === res.response),
                1
            );
            this.$refs.formValidate.validateField('imgurl');
        }
    }
}
</script>

<style lang="scss" scoped>
    
</style>